import type { ShellAdminNavItem } from '@/lib/community-ui-mode';

/** Admin sidebar items for aggregator communities. Add new aggregator options here. */
export const AGGREGATOR_ADMIN_NAV_ITEMS: ShellAdminNavItem[] = [
  { id: 'sub-communities', label: 'Sub Community' },
];
